
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.71 5.288l-2 2a.5.5 0 00.163.82.5.5 0 00.547-.11l2-2a.502.502 0 00-.71-.71z","fill":"#fff","stroke":"#fff","stroke-width":".6"}}),_c('path',{attrs:{"d":"M6.206 9.341l-.64.635a2.1 2.1 0 01-2.79.2 2 2 0 01-.135-2.965l.71-.715a.5.5 0 00-.163-.82.5.5 0 00-.547.11l-.635.64a3.075 3.075 0 00-.335 4.035 3.03 3.03 0 004.535.3l.71-.71a.502.502 0 00-.71-.71zm3.69-7.09a3.09 3.09 0 00-4.065.34l-.54.55a.545.545 0 00-.085.805.5.5 0 00.71 0l.65-.655a2.085 2.085 0 012.785-.2 2 2 0 01.135 2.975l-.71.715a.5.5 0 00.163.82.5.5 0 00.547-.11l.71-.71a3.03 3.03 0 00-.3-4.53z","fill":"#fff","stroke":"#fff","stroke-width":".95"}})])
          )
        }
      }
    